import { jsx } from "react/jsx-runtime";
import { Paragraph } from "@zillow/constellation-10";
import API from "@zillow/mortgage-api-client";
import TextField from "../Fields/TextField.esm.js";
import { FieldConfig } from "./ClosingCostCalculator.utils.esm.js";
import { useCurrentRatesButtonUrl } from "./useCurrentRatesButtonUrl.esm.js";
const InterestRate = ({
  homePrice,
  downPayment
}) => {
  const currentRatesButtonUrl = useCurrentRatesButtonUrl("mortgage-rates", {
    value: homePrice,
    down: downPayment,
    auto: true,
    zip: API.zipcode && API.zipcode.length === 5 ? API.zipcode : null,
    source: "Z_Mortgage_Calc_rates"
  });
  return /* @__PURE__ */ jsx(TextField, { label: "Interest rate", rightAdornment: "%", name: FieldConfig.interestRate.name, config: FieldConfig.interestRate.config, textButtonName: "See current rates", textButtonHref: currentRatesButtonUrl, autoComplete: "off", tooltip: {
    title: "Interest rate",
    body: /* @__PURE__ */ jsx(Paragraph, { children: "A percentage of your loan amount, like 6.25% of $400,000, that is variable based on factors you can influence and others that are market dependent." })
  }, required: true });
};
export {
  InterestRate as default
};
